import axiosClient from "../../../../system/helpers/axiosConfig";

export const getInstantMessagesList = (params) => {
  return axiosClient.get("/api/im", { params }).then((r) => r.data);
};
